import { registerReportPage, type ReportPageDefinition } from '@/features/reports'

const FUNNEL_EXPLORATION_PAGE = {
  routeName: 'FunnelExploration',
  path: 'audience/funnel-exploration',
  layoutKey: 'FUNNEL_EXPLORATION',
  reportIds: [23, 56],
  queryReportIds: [23, 56],
  recomIds: [56],
  navKey: 'funnelExploration',
  titleKey: 'audience.funnelExploration.title',
  updatedDateId: 56,
  headerTitleKey: 'audience.funnelExploration.title',
} satisfies ReportPageDefinition

// v3's client-side `linksName` map routes report 28 here (`{id:28, route:'UserBehavior',
// layout:'USER_BEHAVIOR'}`) — that row is LIVE on v3 main, unlike the sidebar leaf beside it,
// which is commented out (see `../nav.ts`). Registering the page context restores the two
// behaviours that row drove and nothing else: `?report_id=28` resolves to this route, and the
// document title falls back to report 28's server-authored name. It contributes NO nav entry —
// `registeredReportPages()` feeds the route/ingress/title seams, never `registerNavContribution`.
// The route component passes these same values to `ReportPage` as props, so the row is metadata
// for the shared seams rather than a second source of truth.
const USER_BEHAVIOR_PAGE = {
  routeName: 'UserBehavior',
  path: 'audience/user-behavior',
  layoutKey: 'USER_BEHAVIOR',
  reportIds: [28],
  navKey: 'userBehavior',
  titleKey: 'audience.userBehavior.title',
  isNotTab: true,
  updatedDateId: 28,
  headerTitleKey: 'audience.userBehavior.title',
} satisfies ReportPageDefinition

const RFM_CLUSTERING_PAGE = {
  routeName: 'RFMClustering',
  path: 'audience/rfm-clustering',
  layoutKey: 'RFM_CLUSTERING',
  reportIds: [67],
  queryReportIds: [53],
  recomIds: [67],
  navKey: 'rfmClustering',
  titleKey: 'audience.rfm.title',
  isNotTab: true,
} satisfies ReportPageDefinition

/** Register Funnel's report context before its lazy route renders. Idempotent by identity. */
export function registerAudiencePages(): () => void {
  const undos = [
    registerReportPage(FUNNEL_EXPLORATION_PAGE),
    registerReportPage(USER_BEHAVIOR_PAGE),
    registerReportPage(RFM_CLUSTERING_PAGE),
  ]
  return () => {
    for (const undo of undos) undo()
  }
}
